<div class="list-container">
  <div class="row gutters align-top nowrap-md">
    <div class="col-md-10">
      <mat-card appearance="outlined">
        <mat-card-title class="header-title range-bar">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-2">{{sectionTitle}}</div>
              <div class="col-md-8">
                <span>
                  <mat-form-field>
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [formGroup]="dateFormGroup" [rangePicker]="picker">
                      <input matStartDate formControlName="start" placeholder="Start date" (dateChange)="onDateChange()" (dateInput)="onDateChange()">
                      <input matEndDate formControlName="end" placeholder ="End date" (dateChange)="onDateChange()" (dateInput)="onDateChange()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </mat-form-field>
                  <button
                    class = "calendar-view-btn"
                    (click)="navigate(null, 'calendar')"
                    matTooltip="Calendar view">
                    <mat-icon>calendar_month</mat-icon>
                  </button>
                  <button
                    class = "calendar-export-btn"
                    (click) = "quickExportCompanyEventList()"
                    matTooltip="Export list"
                    >
                    <mat-icon>redo</mat-icon>
                  </button>
                </span>
              </div>
              <div class="col-md-2">
                <div class="row vertical-align-baseline">
                  <mat-form-field style="max-width: 70%">
                    <input type="text" matInput [formControl]="userSelect" [matAutocomplete]="auto" placeholder="Filter by attendee..." (focusout)="inputEvent($event)">
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="filterByAttendee($event)" >
                      @for (user of filteredUsers; track user) {
                        <mat-option [value]="user.name">
                          {{user.name}}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                  <button mat-icon-button class="reset-btn mat-elevation-z0" (click)="resetAttendeeEvents()" matTooltip="Reset attendee events" style="max-width: 14%; margin-bottom: 20px">
                    <mat-icon>refresh</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-card-title>
        <mat-card-content>
          @if (Object.keys(filterEvents).length > 0) {
            @for (month of filterEvents | keyvalue: sortKey ; track month) {
              <div>
                @if (month.value['events'].length > 0) {
                  <div class="row month-label" style="justify-content: center">
                    <span>{{month.key}} <small class="small-year">{{month.value['year']}}</small></span>
                  </div>
                }
                @for (event of month.value['events']; track event; let isLast = $last) {
                  <div>
                    <company-events-list-tile [event]="event" [type]="event.companyEvent.companyEventType.name" [isLast]="isLast"></company-events-list-tile>
                  </div>
                }
              </div>
            }
          }
          @if (Object.keys(filterEvents).length==0 && !isLoading) {
            <div style="display: flex; flex-direction: row; justify-content: center; color: #868686">No Upcoming Events for selected dates</div>
          }
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-2">
      <company-events-search></company-events-search>
      <mat-card appearance="outlined" class="bg-cool-gray-6 legend-box" style="margin-top: 12px;">
        <mat-card-title class="legend-header">
          Legend
        </mat-card-title>
        <mat-card-content>
          <ul class="legend-toggles">
            @for (type of listManager.typesList(); track type) {
              <li>
                <mat-checkbox style="margin-left: -16px; margin-bottom: -10px;"
                  [class]="[listManager.getColorClass(type)]"
                  [(ngModel)]="listManager.companyEventTypes[type].checked"
                  [checked]="listManager.companyEventTypes[type].checked"
                  (click)="toggleGroup(type)"
                  name="{{type + 'legendcheck'}}"
                  >
                  <span class="legend-labels">{{ listManager.companyEventTypes[type].label }}</span>
                </mat-checkbox>
              </li>
            }
          </ul>
          <mat-divider></mat-divider>
          <ul class="legend-icons">
            <li>
              <mat-icon
                aria-hidden="false"
                #tooltip="matTooltip"
                matTooltip="CREA Sponsored Event"
                matTooltipPosition="left"
                >diamond</mat-icon
                ><span>CREA Sponsored Event</span>
              </li>
              <li>
                <mat-icon
                  #tooltip="matTooltip"
                  matTooltip="Co-sponsored Event"
                  matTooltipPosition="left"
                  >groups</mat-icon
                  ><span>Co-sponsored Event</span>
                </li>
                <li>
                  <mat-icon
                    class="txt-red"
                    aria-hidden="false"
                    #tooltip="matTooltip"
                    matTooltip="Cancelled Event"
                    matTooltipPosition="left"
                    >warning</mat-icon
                    ><span>Cancelled Event</span>
                  </li>
                  <li>
                    <mat-icon
                      class="warning-grey"
                      #tooltip="matTooltip"
                      matTooltip="Postponed Event"
                      matTooltipPosition="left"
                      >warning</mat-icon
                      ><span>Postponed Event</span>
                    </li>
                  </ul>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
